export const create_exchange_order_confirm = `mutation create_exchange_order_confirm($secret: String!, $token: String){
    create_exchange_order_confirm(secret: $secret, token: $token)
}`;
